<template>
  <div>
    <!-- PROFILE HEADER -->
    <section class="mb-4 mb-xl-5">
      <div class="container">
        <div class="profile-header">
          <div class="header-image" :style="coverImage">
          </div>
          <div class="header-data pb-4 pb-xl-5">
            <div class="profile-image" :style="profileImage"></div>
            <div class="actions" v-if="user">
              <!-- <UserDonationButton
                :user="user"
                class="mr-2"
              /> -->
              <template v-if="authUser">
                <template v-if="user.id != authUser.id">
                  <FollowButton
                    :disabled="!authenticated"
                    :isFollowed="user.is_followed"
                    :idToFollow="user.id"
                    @follow-toggled="$emit('follow-toggled')"
                    color="btn-white"
                  />
                  <NotificationButton
                    class="actions-notification"
                    :disabled="!authenticated"
                    :isToNotify="user.is_notification"
                    :isFollowed="user.is_followed"
                    :idToFollow="user.id"
                    @notification-toggled="$emit('notification-toggled')"
                    color="btn-white"
                  />
                </template>
                <Button
                  class="btn-white"
                  v-b-modal.edit-user-profile
                  v-else
                >
                  Editar perfil
                </Button>
              </template>
            </div>
            <div class="d-flex flex-column flex-lg-row pt-5 pt-md-4 pt-lg-5 justify-content-lg-center align-items-lg-center">
              <div class="social mt-2 mb-2 order-2 order-lg-1 col-lg-3 my-lg-0">
                <ul class="d-flex justify-content-center align-items-center mb-0">
                  <li
                    v-if="user && user.social.twitter"
                  >
                    <a :href="user.social.twitter" target="_blank"><i class="fa fa-twitter"></i></a>
                  </li>
                  <li
                    v-if="user && user.social.facebook"
                  >
                    <a :href="user.social.facebook" target="_blank"><i class="fa fa-facebook"></i></a>
                  </li>
                  <li
                    v-if="user && user.social.instagram"
                  >
                    <a :href="user.social.instagram" target="_blank"><i class="fa fa-instagram"></i></a>
                  </li>
                  <li
                    v-if="user && user.social.linkedin"
                  >
                    <a :href="user.social.linkedin" target="_blank"><i class="fa fa-linkedin"></i></a>
                  </li>
                  <li
                    v-if="user && user.social.youtube"
                  >
                    <a :href="user.social.youtube" target="_blank"><i class="fa fa-youtube-play"></i></a>
                  </li>
                  <li
                    v-if="user && user.social.external"
                  >
                    <a :href="user.social.external" target="_blank"><i class="fa fa-link"></i></a>
                  </li>
                </ul>
              </div>
              <div class="order-1 order-lg-2 mt-2 col-lg-5 mt-lg-0">
                <div class="d-flex justify-content-center align-items-center">
                  <router-link
                    class="d-inline-block user-name"
                    :to="{ name: 'users.show', params: { username: user ? user.username : 'username' } }"
                  >
                    <h2 class="font-weight-bold font-size-large mb-0 text-color1 px-lg-4">
                      {{ user && user.name }}
                    </h2>
                  </router-link>
                </div>
                <div>
                  <router-link
                    class="d-inline-block"
                    :to="{ name: 'users.show', params: { username: user ? user.username : 'username' } }"
                  >
                    <span class="text-color1">
                      <span class="text-color2" v-if="user">@</span>{{ user && user.username }}
                    </span>
                    <BaseIcon
                      v-if="user && user.is_verified"
                      size="xSmall"
                      color="color2"
                      class="verified-wrap mr-1"
                    >
                      <VerifiedIcon
                        class="profile"
                      />
                    </BaseIcon>
                    <ScrivProIcon
                      v-if="user && user.is_scriv_pro_enabled"
                      class="font-size-small"
                    />
                  </router-link>
                  <router-link
                    class="d-inline-block editUsernameIcon"
                    :to="{ name: 'settings.show' }"
                    v-if="user && authUser && user.id == authUser.id"
                  >
                    <BaseIcon
                      size="small"
                    >
                      <PencilIcon />
                    </BaseIcon>
                  </router-link>
                </div>
              </div>
              <div class="order-3 mt-2 col-lg-3">
                <ul class="d-flex justify-content-center align-items-center mb-0">
                  <li class="mr-4">
                    <router-link
                      :to="{ name: 'users.show', params: { username: user ? user.username : 'username' } }"
                      class="link-color1"
                    >
                      <span class="font-weight-bold d-block">Publicações</span>
                      <span>{{ user && user.posts_count }}</span>
                    </router-link>
                  </li>
                  <li class="mr-4">
                    <router-link
                      :to="{ name: 'followers.index', params: { username: user ? user.username : 'username' } }"
                      class="link-color1"
                    >
                      <span class="font-weight-bold d-block">Seguidores</span>
                      <span>{{ user && user.followers_count }}</span>
                    </router-link>
                  </li>
                  <li>
                    <router-link
                      :to="{ name: 'following.index', params: { username: user ? user.username : 'username' } }"
                      class="link-color1"
                    >
                      <span class="font-weight-bold d-block">Seguindo</span>
                      <span>{{ user && user.following_count }}</span>
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
            <!-- AWARDS -->
            <section
              class="awards mt-3"
              v-if="awards.length > 0"
            >
              <div class="container">
                <AwardList
                  type="user"
                  :target="user.id"
                  :awards="awards"
                />
              </div>
            </section> <!-- END AWARDS -->
          </div>
        </div>

      </div>
    </section> <!-- END PROFILE HEADER -->
    <UserEditProfileModal
      :user="user"
      @profile-updated="$emit('profile-updated')"
    />
  </div>
</template>

<script>

import variables from '@/mixins/variables'
import AwardsService from '@/modules/awards/services/awards-service'
import { mapState } from 'vuex'

import AwardList from '@/components/awards/AwardList'
import BaseIcon from '@/components/common/Icon/BaseIcon.vue'
import Button from '@/components/common/Button/Button.vue'
import FollowButton from '@/components/follow/FollowButton.vue'
import NotificationButton from '@/components/follow/NotificationButton.vue'
import PencilIcon from '@/components/common/Icon/PencilIcon.vue'
import VerifiedIcon from '@/components/common/Icon/VerifiedIcon.vue'
// import UserDonationButton from '@/components/user/UserDonationButton'
import UserEditProfileModal from '@/components/user/UserEditProfileModal.vue'
import ScrivProIcon from '@/components/common/Icon/ScrivProIcon'

export default {
  name: 'UserProfileHeader',
  mixins: [variables],
  components: {
    AwardList,
    BaseIcon,
    Button,
    FollowButton,
    NotificationButton,
    PencilIcon,
    VerifiedIcon,
    UserEditProfileModal,
    // UserDonationButton,
    ScrivProIcon
  },
  props: ['user'],
  data () {
    return {
      editProfile: false,
      awards: []
    }
  },
  computed: {
    coverImage () {
      return {
        backgroundImage: this.user ? `url('${this.user.cover}')` : `url('${this.noCoverUrl}')`
      }
    },
    profileImage () {
      return {
        backgroundImage: this.user ? `url('${this.user.avatar}')` : `url('${this.noAvatarUrl}')`
      }
    },
    ...mapState('auth', {
      authenticated: state => state.authenticated
    }),
    ...mapState('users', {
      authUser: state => state.user
    })
  },
  created () {
    if (this.user) this.getAwards()
  },
  watch: {
    user (newValue, oldValue) {
      if (newValue) this.getAwards()
    }
  },
  methods: {
    async getAwards () {
      try {
        const awards = await AwardsService.getAwards({ type: 'user', target: this.user.id })
        this.awards = awards
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.profile-header {
  position: relative;

  .header-image {
    background-color: #fff;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    width: 100%;
    height: 130px;
    -webkit-border-radius: $radius_regular;
    -moz-border-radius: $radius_regular;
    border-radius: $radius_regular;
    -webkit-box-shadow: 0 0 10px 0 rgba(0,0,0,0.1);
    box-shadow: 0 0 10px 0 rgba(0,0,0,0.1);
    position: relative;

    @include tablet {
      height: 210px;
    }

    @include desktop {
      height: 260px;
    }

    @include desktop-lg {
      height: 280px;
    }

  }

  .editUsernameIcon {
    ::v-deep {
      svg {
        width: 24px;

        @include desktop {
          width: 22px;
        }
      }
    }
  }

  .header-data {
    background-color: #fff;
    -webkit-border-radius: $radius_regular;
    -moz-border-radius: $radius_regular;
    border-radius: $radius_regular;
    -webkit-box-shadow: 0 0 10px 0 rgba(0,0,0,0.1);
    box-shadow: 0 0 10px 0 rgba(0,0,0,0.1);
    text-align: center;
    position: relative;
    z-index: 2;
    margin-top: -15px;

    .profile-image {
      position: absolute;
      top: -82px;
      left: calc(50% - 50px);
      -webkit-border-radius: 150px;
      -moz-border-radius: 150px;
      border-radius: 150px;
      -webkit-box-shadow: 0 0 10px 0 rgba(0,0,0,0.2);
      box-shadow: 0 0 10px 0 rgba(0,0,0,0.2);
      width: 100px;
      height: 100px;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;

      @include tablet {
        top: -126px;
        height: 150px;
        width: 150px;
        left: calc(50% - 75px);
      }

      @include desktop {
        height: 180px;
        width: 180px;
        left: calc(50% - 90px);
        top: -146px;
      }

      @include desktop-lg {
        top: -150px;
      }
    }

    .actions {
      display: flex;
      justify-content: space-between;
      width: 95%;
      position: absolute;
      right: 10px;
      top: 10px;

      @include tablet {
        top: -56px;
        justify-content: end;
      }

      .actions-notification {
        margin-left: 10px;
      }
    }

    .social {
      li {
        margin-right: $spacing_small;

        &:last-child {
          margin-right: 0;
        }

        a {
          color: $color1;
          border-radius: 30px;
          display: block;
          width: 40px;
          height: 40px;
          border: 1px solid $color1;
          font-size: 21px;
          line-height: 37px;

          &:hover {
            color: $color2;
            border-color: $color2;
          }
        }
      }
    }

    .user-name {
      overflow-wrap: break-word;
      max-width: 100%;
    }

  }
}

.verified-wrap {
  height: 28px;
  display: inline-block;
  margin-top: 4px;
}
</style>
